import React, { Component } from 'react';
import { isEqual } from 'lodash';
import { connect } from 'react-redux';
import styles from './InspectionCarouselFooter.css';

const debug = _debug('app:InspectionCarouselFooter');
class InspectionCarouselFooter extends Component {
  static propTypes = {
    buttonCarouselAction: React.PropTypes.func,
    clickedIndex: React.PropTypes.number,
    strings: React.PropTypes.shape({}),
    wholeData: React.PropTypes.shape({}),
    currentLanguage: React.PropTypes.strings
  }

  constructor(props) {
    super(props);
    debug(props);
    this.state = {
      commentPopup: false,
      noContactDisabled: false,
      duplicateInspectionDisabled: false,
      submitEnabled: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const initialWholeData = this.props.wholeData;
    const wholeData = nextProps.wholeData;
    if (!isEqual(this.props.wholeData, nextProps.wholeData)) {
      this.setState({
        noContactDisabled: wholeData.cica_customerexperience ||
        wholeData.cica_trainingopportunity,
        duplicateInspectionDisabled: wholeData.cica_customerexperience ||
        wholeData.cica_trainingopportunity,
        submitEnabled: wholeData.cica_customerexperience &&
        wholeData.cica_trainingopportunity
      });
    } else {
      this.setState({
        noContactDisabled: initialWholeData.cica_customerexperience ||
        initialWholeData.cica_trainingopportunity,
        duplicateInspectionDisabled: initialWholeData.cica_customerexperience ||
        initialWholeData.cica_trainingopportunity,
        submitEnabled: initialWholeData.cica_customerexperience &&
        initialWholeData.cica_trainingopportunity
      });
    }
  }

  render() {
    const { strings } = this.props;
    return (
      <div className={this.props.currentLanguage === 'en' ? styles.carouselInspectionFooter : styles.carouselInspectionFooterEs}>
        <button
          type="button"
          className={this.state.noContactDisabled ? styles.disabledFooterCarouselComponent :
           styles.footerCarouselComponent}
          onClick={() => !this.state.noContactDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'script')}
        >
          <input //eslint-disable-line
            type="image"
            src="static/info_icon.png"
            onClick={() => !this.state.noContactDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'script')}
            alt="Info"
            className={styles.footerCarouselButton}
          />
          <span //eslint-disable-line
            className={styles.footerCarouselLabel}
            onClick={() => !this.state.noContactDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'script')}
          >{strings.script}
          </span>
        </button>
        <button
          type="button"
          className={styles.footerCarouselComponent}
          onClick={() => !this.wholeData && this.props.buttonCarouselAction(this.props.clickedIndex, 'customerExperience')}
        >
          <input //eslint-disable-line
            type="image"
            src="static/customer_experience.png"
            alt={strings.customerexperience}
            className={styles.footerCarouselButton}
            onClick={() => !this.wholeData && this.props.buttonCarouselAction(this.props.clickedIndex, 'customerExperience')}
          />
          <span //eslint-disable-line
            className={styles.footerCarouselLabel}
            onClick={() => !this.wholeData && this.props.buttonCarouselAction(this.props.clickedIndex, 'customerExperience')}
          >{strings.customerexperience}
          </span>
        </button>
        <button
          type="button"
          className={styles.footerCarouselComponent}
          onClick={() => !this.wholeData && this.props.buttonCarouselAction(this.props.clickedIndex, 'trainingOpportunity')}
        >
          <input //eslint-disable-line
            type="image"
            src="static/training opp.png"
            alt={strings.trainingopportunity}
            className={styles.footerCarouselButton}
            onClick={() => !this.wholeData && this.props.buttonCarouselAction(this.props.clickedIndex, 'trainingOpportunity')}
          />
          <span //eslint-disable-line
            className={styles.footerCarouselLabel}
            onClick={() => !this.wholeData && this.props.buttonCarouselAction(this.props.clickedIndex, 'trainingOpportunity')}
          >{strings.trainingopportunity}
          </span>
        </button>
        <button
          type="button"
          className={this.state.noContactDisabled ? styles.disabledFooterCarouselComponent :
           styles.footerCarouselComponent}
          onClick={() => !this.state.noContactDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'noContact')}
        >
          <input //eslint-disable-line
            type="image"
            src="static/no contact.png"
            alt={strings.nocontact}
            onClick={() => !this.state.noContactDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'noContact')}
            className={styles.footerCarouselButton}
          />
          <span //eslint-disable-line
            className={styles.footerCarouselLabel}
            onClick={() => !this.state.noContactDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'noContact')}
          >{strings.nocontact}
          </span>
        </button>
        <button
          type="button"
          className={styles.footerCarouselComponent}
          onClick={() => this.props.buttonCarouselAction(this.props.clickedIndex, 'comments')}
        >
          <input //eslint-disable-line
            type="image"
            src="static/comments.png"
            alt={strings.comments}
            className={styles.footerCarouselButton}
            onClick={() => this.props.buttonCarouselAction(this.props.clickedIndex, 'comments')}
          />
          <span //eslint-disable-line
            className={styles.footerCarouselLabel}
            onClick={() => this.props.buttonCarouselAction(this.props.clickedIndex, 'comments')}
          >{strings.comments}
          </span>
        </button>
        <button
          type="button"
          className={this.state.duplicateInspectionDisabled ? styles.disabledFooterCarouselComponent
           : styles.footerCarouselComponent}
          onClick={() => !this.state.duplicateInspectionDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'duplicateInspection')}
        >
          <input //eslint-disable-line
            type="image"
            src="static/duplicate.png"
            alt={strings.duplicateinspection}
            className={styles.footerCarouselButton}
            onClick={() => !this.state.duplicateInspectionDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'duplicateInspection')}
          />
          <span //eslint-disable-line
            className={styles.footerCarouselLabel}
            onClick={() => !this.state.duplicateInspectionDisabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'duplicateInspection')}
          >{strings.duplicateinspection}
          </span>
        </button>
        <button
          type="button"
          className={this.state.submitEnabled ? styles.footerCarouselComponent :
           styles.disabledFooterCarouselComponent}
          onClick={() => this.state.submitEnabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'submit')}
        >
          <input //eslint-disable-line
            type="image"
            src="static/submit.png"
            alt={strings.submit}
            className={styles.footerCarouselButton}
            onClick={() => this.state.submitEnabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'submit')}
          />
          <span //eslint-disable-line
            className={styles.footerCarouselLabel}
            onClick={() => this.state.submitEnabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'submit')}
          >{strings.submit}
          </span>
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentLanguage: state.assign && state.assign.currentLanguage
});

export default connect(mapStateToProps, null)(InspectionCarouselFooter);



// WEBPACK FOOTER //
// ./src/components/InspectionCarouselFooter/InspectionCarouselFooter.js